module.exports = __webpack_public_path__ + "static/media/Is-Your-CX-Program-Falling-Short.026f1448.jpeg";